import { controls } from "../../controls";

const rp952 = {
  label: "Annexure I",
  pageLabel: "Annexure I",
  starting: true,
  url: "rp952",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({tab: "filter",label: "From Date",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",isRequired:true,name:"as_on_date",width:"col-sm-2"}),

    ...controls.displayText({tab: "filter",label: "",width:"col-sm-2 "}),

    ...controls.displayText({tab: "filter",label: "To Date",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",isRequired:true,name:"as_on_date",width:"col-sm-2"}),
        
    ...controls.displayText({tab: "filter",label: "",width:"col-sm-2"}),

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-2" }),
    ...controls.perPage({ tab: 'filter'}),
  ],

  //form: [
  //  ...controls.displayText({ label: "Crop Type Code", width: "col-sm-1", star: true }),
  //  ...controls.text({ name: "crop_type", isRequired: true }),
  //  ...controls.displayText({ width: "col-sm-3" }),

  //  ...controls.displayText({ label: "Crop Type Desc", width: "col-sm-1", star: true }),
  //  ...controls.text({ name: "crop_type_display", isRequired: true }),
  //  ...controls.displayText({ width: "col-sm-3" }),

  //],
  form:[],

  history: {
    perPage: 10,
    reportHeader: "Particulars of Investment Transaction",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
      {
        Header: "Sr. No.",
        accessor: "Sr_No.",
        width:20,
        rwidth:"*"

      },
      {
        Header: "Category",
        accessor: "Category",
        width: 200,
        rwidth: 200
      },
      {
        accessor: "Book_Values_as_on",
        Header: "Book Values as on 31/3/2019",
        type:"currency",
        rwidth:"*"
      },
      {
        accessor:  "Purchase-during_the_period",
        Header:"Purchase during the period 1/10/2018 to 31/3/2019",
        type:"currency",
        rwidth:"*"
      },
      {
        accessor: "Sale_during_the_period",
        Header: "Sale during the period 1/10/2019 to 31/3/2019",
        type:"currency",
        rwidth:"*"
      },
      {
        accessor: "Book_Values_as_on",
        Header: "Book Values as on 31/3/2019",
        type:"currency",
        rwidth:"*"
      },
      {
        accessor: "Face_Values_as_on",
        Header: "Face Values as on 31/3/2019",
        type:"currency",
        rwidth:"*"
      },
      {
        accessor: "Book_Values_as_on",
        Header: "Market Values as on 31/3/2019",
        type:"currency",
        rwidth:"*"
      },
      {
        accessor: "Sale_Purchase_during_year",
        Header: "Profit()+ Loss(-) incurred by the bank on account of sale/purchase during the year",
        type:"currency",
        rwidth:"*"
      },

      {
        Header: "Book Values of documents title",
        columns: [
          {
            Header: "Physical Form",
            accessor: "Physical_form",
            rwidth:"*"
          },
          {
            Header: "Demat form",
            accessor: "Demat_form",
            rwidth:"*"
          }
        ]
      }
    ]
  }
};

export default rp952;